module.exports = __webpack_public_path__ + "static/12-0ecb53927a91a60264e9a6f43511d64e.jpg";